import { Icon } from './types';

export const ArrowDown = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="arrow-down"
    {...svgProps}
  >
    <path
      d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
